export const HPKE_VERSION = new TextEncoder().encode('HPKE-v1');

export type SealedDataWithEncappedKey = {
  encappedKey: Uint8Array<ArrayBuffer>;
  cipherText: Uint8Array<ArrayBuffer>;
};

export type Encapsulation = {
  encappedKey: Uint8Array<ArrayBuffer>;
  sharedSecret: Uint8Array<ArrayBuffer>;
};

export type PublicKey = CryptoKey;
export type PrivateKey = CryptoKey;

export type AsymmetricKeyPair = {
  publicKey: PublicKey;
  privateKey: PrivateKey;
};
